var map = {
	"./auth.json": "../../packages/i18n/src/ru/auth.json",
	"./banners.json": "../../packages/i18n/src/ru/banners.json",
	"./business-meta.json": "../../packages/i18n/src/ru/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/ru/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/ru/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/ru/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/ru/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/ru/company/common.json",
	"./company/create.json": "../../packages/i18n/src/ru/company/create.json",
	"./company/options.json": "../../packages/i18n/src/ru/company/options.json",
	"./company/page.json": "../../packages/i18n/src/ru/company/page.json",
	"./company/users.json": "../../packages/i18n/src/ru/company/users.json",
	"./errors.json": "../../packages/i18n/src/ru/errors.json",
	"./group-preview.json": "../../packages/i18n/src/ru/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/ru/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/ru/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/ru/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/ru/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/ru/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/ru/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/ru/layout.json",
	"./modals.json": "../../packages/i18n/src/ru/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/ru/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/ru/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/ru/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/ru/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/ru/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/ru/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/ru/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/ru/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/ru/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/ru/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/ru/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/ru/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/ru/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/ru/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/ru/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/ru/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/ru/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/ru/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/ru/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/ru/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/ru/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/ru/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/ru/shared.json",
	"./ui.json": "../../packages/i18n/src/ru/ui.json",
	"./validation.json": "../../packages/i18n/src/ru/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/ru sync recursive \\.json$";